"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactHookForm = require("react-hook-form");
var _dateFns = require("date-fns");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _lodash = require("lodash");
var _mapState = require("../../../../dist/desktop/hooks/mapState");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var now = new Date();
var thirtyMinutesAgo = (0, _dateFns.subMinutes)(now, 30);
var dateTimeLocalNow = (0, _dateFns.format)(now, 'yyyy-MM-dd/H:mm').toString().replace('/', 'T');
var dateTimeLocalThen = (0, _dateFns.format)(thirtyMinutesAgo, 'yyyy-MM-dd/H:mm').toString().replace('/', 'T');
var DEFAULT_DATEPICKERS = {
  from: dateTimeLocalThen,
  to: dateTimeLocalNow
};
var isMobileViewport = function isMobileViewport(width) {
  return width <= 992;
};
var OptionsBar = function OptionsBar(props) {
  var _mapState$playback, _mapState$playback2;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMobileDatepicker = _useState2[0],
    setShowMobileDatepicker = _useState2[1];
  var selected = props.selected,
    selectedText = props.selectedText,
    unselect = props.unselect,
    endPlayback = props.endPlayback;
  var _useForm = (0, _reactHookForm.useForm)({
      mode: 'all',
      defaultValues: DEFAULT_DATEPICKERS
    }),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.formState.errors,
    watch = _useForm.watch,
    setError = _useForm.setError;
  var _useMapState = (0, _mapState.useMapState)(),
    mapState = _useMapState.mapState,
    showScrubber = _useMapState.showScrubber,
    hideScrubber = _useMapState.hideScrubber,
    setPlaybackRange = _useMapState.setPlaybackRange,
    stopPlayback = _useMapState.stopPlayback;
  var _useState3 = (0, _react.useState)(isMobileViewport(window.innerWidth)),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  (0, _react.useEffect)(function () {
    var onResize = function onResize() {
      return setIsMobile(isMobileViewport(window.innerWidth));
    };
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  var handleToggleScrubber = function handleToggleScrubber() {
    if (mapState.playback.showScrubber) {
      endPlayback();
    } else {
      showScrubber();
    }
  };
  var handleCloseModal = function handleCloseModal() {
    return setShowMobileDatepicker(false);
  };
  var onSubmit = function onSubmit(data) {
    var from = Math.floor(new Date(data.from).getTime() / 1000);
    var to = Math.floor(new Date(data.to).getTime() / 1000);
    setPlaybackRange(from, to);
    handleCloseModal();
    handleToggleScrubber();
  };
  var hideDatePickers = selected === null || selected === void 0 ? void 0 : selected.type;
  return /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "m-0 ",
    id: "option-bar"
  }, hideDatePickers ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex ".concat(isMobile ? 'justify-content-center' : 'justify-content-start', " align-items-center pb-3")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-2 text-light"
  }, selected && selectedText ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    size: "lg",
    color: "white",
    icon: _freeSolidSvgIcons.faCircleXmark,
    onClick: function onClick() {
      return unselect();
    }
  }) : ''), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-light"
  }, selectedText ? "Current Selection: ".concat(selectedText) : '')) : /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mt-2 mb-0 mx-0 align-content-center justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "pb-2"
  }, !isMobile && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Col
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Label, {
    className: "text-light"
  }, "From"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Control, _extends({
    size: "sm",
    type: "datetime-local",
    endDate: "today",
    isInvalid: errors.from
  }, register('from', {
    required: true,
    validate: function validate(v) {
      if ((0, _dateFns.isFuture)(new Date(v).getTime())) {
        return setError('from');
      }
    }
  })))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Col
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Label, {
    className: "text-light"
  }, "To"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Control, _extends({
    size: "sm",
    type: "datetime-local",
    isInvalid: errors.to
  }, register('to', {
    required: true,
    validate: function validate(v) {
      var from = watch('from');
      if (!from) {
        return true;
      }
      var timeLimit = 30; // thirty minutes is the maximum time slice
      var desiredStart = new Date(from).getTime();
      var desiredEnd = new Date(v).getTime();
      if (desiredEnd < desiredStart) {
        setError('to', {
          type: 'invalid',
          message: 'End date cannot be before start date.'
        });
        return false;
      }
      var diffInHours = (0, _dateFns.differenceInMinutes)(desiredEnd, desiredStart);
      if (diffInHours < 0 || diffInHours > timeLimit) {
        setError('to', {
          type: 'invalid',
          message: "Unable to query more than two days' time."
        });
      }
    }
  }))), errors.to && /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, errors.to.message))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Col,
    className: "mt-auto".concat(isMobile ? ' d-flex justify-content-center' : '')
  }, isMobile ? /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Button, {
    size: "sm",
    variant: "outline-light",
    onClick: function onClick() {
      if (!mapState.playback.showScrubber) {
        return setShowMobileDatepicker(true);
      }
      return handleToggleScrubber();
    }
  }, mapState !== null && mapState !== void 0 && (_mapState$playback = mapState.playback) !== null && _mapState$playback !== void 0 && _mapState$playback.showScrubber ? 'Close' : 'Open', " Playback Scrubber") : /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Button, {
    size: "sm",
    variant: "outline-light",
    onClick: handleSubmit(onSubmit)
  }, mapState !== null && mapState !== void 0 && (_mapState$playback2 = mapState.playback) !== null && _mapState$playback2 !== void 0 && _mapState$playback2.showScrubber ? 'Close' : 'Open', " Playback Scrubber"))))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Modal, {
    size: "lg",
    centered: true,
    animation: true,
    show: showMobileDatepicker,
    onHide: handleCloseModal
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Modal.Body, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Label, {
    column: true,
    xs: "auto"
  }, "From:"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Control, _extends({
    label: "From:",
    size: "sm",
    type: "datetime-local",
    endDate: "today",
    isInvlalid: errors.from
  }, register('from', {
    required: true,
    validate: function validate(v) {
      if ((0, _dateFns.isFuture)(new Date(v).getTime())) {
        return setError('from');
      }
    }
  })))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Label, {
    column: true,
    xs: "auto"
  }, "To:"), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Control, _extends({
    label: "To",
    size: "sm",
    type: "datetime-local",
    isInvalid: errors.to
  }, register('to', {
    required: true,
    validate: function validate(v) {
      var from = watch('from');
      if (!from) {
        return true;
      }
      var timeLimit = 30; // thirty minutes is the maximum time slice
      var desiredStart = new Date(from).getTime();
      var desiredEnd = new Date(v).getTime();
      if (desiredEnd < desiredStart) {
        setError('to', {
          type: 'invalid',
          message: 'End date cannot be before start date.'
        });
        return false;
      }
      var diffInHours = (0, _dateFns.differenceInMinutes)(desiredEnd, desiredStart);
      if (diffInHours < 0 || diffInHours > timeLimit) {
        setError('to', {
          type: 'invalid',
          message: "Unable to query more than two days' time."
        });
      }
    }
  }))), errors.to && /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, errors.to.message)), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "justify-content-center"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Button, {
    className: "mt-3",
    size: "sm",
    variant: "info",
    onClick: handleSubmit(onSubmit)
  }, "Submit")))));
};
var _default = OptionsBar;
exports["default"] = _default;